import React from 'react';
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
// NOTE: The old "Recent Activity" DM/comment feed has been commented out (see the
// big block at the bottom of this file) and the Interactions tab now renders the
// Zap Link Analytics panel instead. The old imports are kept so the commented
// feed can be restored as-is if needed.
// import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '../../../../components/tailwind-component/ui/card';
// import { Badge } from './ui/badge';
// import { Button } from './ui/button';
// import { ExternalLink, MessageSquare, Calendar, Send } from 'lucide-react';
// import { InstagramDMAutomation } from "../../../../core/services/dm-automation-instagram.service";
import { connect } from 'react-redux';
import { Loading, UserLogin } from "../../../../../redux/action";
// import * as gtUtil from "../../../../core/utility";
// import { AutomationActivity } from 'custom-type';
import { ZapAnalyticsPanel } from './ZapAnalyticsPanel';
import { ZapFormResponses } from './ZapFormResponses';

// const instagramDMAutomationService: InstagramDMAutomation = new InstagramDMAutomation();

interface ActivityLogProps {
  loading: (data: any) => any;
  UserReducer: any;
  updateUser: any;
}

const ActivityLog: React.FC<ActivityLogProps> = (props: ActivityLogProps) => {
  // The Interactions tab now shows the influencer's own Zap Link Analytics.
  return (
    <>
      {Boolean(props.UserReducer?.influencer_id) && (
        <>
          {/* Renders nothing unless the creator has built a form, so this tab is
              unchanged for everyone who only uses Zap Links. */}
          <ZapFormResponses influencerId={props.UserReducer.influencer_id} />
          <ZapAnalyticsPanel influencerId={props.UserReducer.influencer_id} />
        </>
      )}
    </>
  );
};

/* ============================================================================
 * OLD INTERACTIONS CODE — "Recent Activity" automated DM / comment feed.
 * Commented out per request (kept here so the logic isn't lost). To restore,
 * re-enable the imports at the top and swap this implementation back in.
 * ----------------------------------------------------------------------------
 *
 * const ActivityLog: React.FC<ActivityLogProps> = (props: ActivityLogProps) => {
 *   const [activities, setActivities] = useState<AutomationActivity[]>([]);
 *   // pagination states
 *   const [page, setPage] = useState(1);
 *   const [hasMore, setHasMore] = useState(true);
 *   const [isLoading, setIsLoading] = useState(false);
 *   const loadMoreRef = useRef<HTMLDivElement | null>(null);
 *   const LIMIT = 5;
 *   // end pagination states
 *
 *   const formatTimeAgo = (timestamp: string) => {
 *     const utcTimestamp = timestamp.endsWith("Z") ? timestamp : `${timestamp}Z`;
 *     const date = new Date(utcTimestamp);
 *     const nowUtcMs = Date.now();
 *     const diffMs = nowUtcMs - date.getTime();
 *     const diffSecs = Math.floor(diffMs / 1000);
 *     const diffMins = Math.floor(diffSecs / 60);
 *     const diffHours = Math.floor(diffMins / 60);
 *     const diffDays = Math.floor(diffHours / 24);
 *     if (diffSecs < 60) return `${diffSecs}s ago`;
 *     if (diffMins < 60) return `${diffMins}m ago`;
 *     if (diffHours < 24) return `${diffHours}h ago`;
 *     return `${diffDays}d ago`;
 *   };
 *
 *   async function getIgAutomationsActivities() {
 *     try {
 *       if (isLoading || !hasMore) return;
 *       setIsLoading(true);
 *       const res = await instagramDMAutomationService.getIgAutomationsActivities({
 *         influencer_id: props.UserReducer.influencer_id,
 *         page,
 *         limit: LIMIT,
 *       });
 *       if (res.status === gtUtil.Constants.SUCCESS && Array.isArray(res.data.rows)) {
 *         setActivities(prev => [...prev, ...res.data.rows]);
 *         if (res.data.rows.length < LIMIT) {
 *           setHasMore(false);
 *         } else {
 *           setPage(prev => prev + 1);
 *         }
 *       } else if (res.status === gtUtil.Constants.DB_QUERY_NO_RECORD_FOUND) {
 *         setHasMore(false);
 *       }
 *     } catch (error) {
 *       console.error("Error fetching IG Automations:", error);
 *     } finally {
 *       setIsLoading(false);
 *     }
 *   }
 *
 *   useEffect(() => {
 *     if (!hasMore || isLoading) return;
 *     const observer = new IntersectionObserver(
 *       (entries) => {
 *         if (entries[0].isIntersecting) {
 *           getIgAutomationsActivities();
 *         }
 *       },
 *       { threshold: 0.5 }
 *     );
 *     if (loadMoreRef.current) {
 *       observer.observe(loadMoreRef.current);
 *     }
 *     return () => {
 *       if (loadMoreRef.current) {
 *         observer.unobserve(loadMoreRef.current);
 *       }
 *     };
 *   }, [hasMore, isLoading]);
 *
 *   useEffect(() => {
 *     setActivities([]);
 *     setPage(1);
 *     setHasMore(true);
 *     getIgAutomationsActivities();
 *   }, []);
 *
 *   const ActivitySkeleton = () => (
 *     <div className="flex items-start gap-4 p-3 lg:p-4 border rounded-lg animate-pulse">
 *       <div className="flex-1 min-w-0">
 *         <div className="flex items-center gap-2 mb-3">
 *           <div className="h-4 w-24 bg-gray-200 rounded" />
 *           <div className="h-3 w-3 bg-gray-200 rounded-full" />
 *           <div className="h-4 w-16 bg-gray-200 rounded" />
 *           <div className="h-3 w-3 bg-gray-200 rounded-full" />
 *           <div className="h-3 w-28 bg-gray-200 rounded" />
 *         </div>
 *         <div className="border border-gray-200 rounded-lg p-3 mb-2">
 *           <div className="h-3 w-20 bg-gray-200 rounded mb-2" />
 *           <div className="space-y-2">
 *             <div className="h-3 w-full bg-gray-200 rounded" />
 *             <div className="h-3 w-5/6 bg-gray-200 rounded" />
 *           </div>
 *         </div>
 *         <div className="flex items-center gap-4 mt-3">
 *           <div className="h-3 w-24 bg-gray-200 rounded" />
 *           <div className="h-3 w-16 bg-gray-200 rounded" />
 *         </div>
 *       </div>
 *     </div>
 *   );
 *
 *   return (
 *     <Card className='p-0 border-0 bg-transparent' >
 *       <CardHeader className='p-0'>
 *         <div className='mb-2'>
 *           <CardTitle>Recent Activity</CardTitle>
 *           <CardDescription>
 *             View all automated comment replies and DMs sent to users
 *           </CardDescription>
 *         </div>
 *       </CardHeader>
 *       <CardContent className='px-0'>
 *         <div className="space-y-4">
 *           {isLoading && activities.length === 0 && (
 *             [...Array(5)].map((_, i) => <ActivitySkeleton key={i} />)
 *           )}
 *           {activities.length === 0 ? (
 *             <div className="text-center py-12 text-gray-500">
 *               <MessageSquare className="w-12 h-12 mx-auto mb-3 opacity-30" />
 *               <p>No activity yet</p>
 *               <p className="text-sm">
 *                 Automated DMs will appear here when users trigger your rules
 *               </p>
 *             </div>
 *           ) : (
 *             activities.map((activity) => {
 *               return (
 *               <div
 *                 key={activity.ig_automation_post_comment_id}
 *                 className="flex items-start gap-4 p-3 lg:p-4 border bg-white rounded-lg hover:bg-gray-50 transition-colors"
 *               >
 *                 <div className="flex-1 min-w-0">
 *                   <div className="flex items-center gap-2 mb-2 flex-wrap">
 *                     <span className="text-[#00aae5]">@{activity.from_username}</span>
 *                     <span className="text-gray-400">.</span>
 *                     <Badge variant="outline" className="text-xs z-0">
 *                       {activity.keyword}
 *                     </Badge>
 *                     {activity.automation_name && (
 *                       <>
 *                         <span className="text-gray-400">.</span>
 *                         <span className="text-xs text-gray-500">{activity.automation_name}</span>
 *                       </>
 *                     )}
 *                   </div>
 *                   <div className="space-y-2 mb-3">
 *                     {activity.text && (
 *                       <div className="border border-blue-200 rounded-lg p-3">
 *                         <div className="flex items-center gap-2 mb-1">
 *                           <MessageSquare className="w-3 h-3 text-[#00aae5]" />
 *                           <span className="text-xs text-[#00aae5]">Comment</span>
 *                         </div>
 *                         <p className="text-sm text-[#2b2b2b]">{activity.text}</p>
 *                       </div>
 *                     )}
 *                     {activity.reply_text && activity.reply_text.trim() != '' && (
 *                       <div className="border border-blue-200 rounded-lg p-3">
 *                         <div className="flex items-center gap-2 mb-1">
 *                           <MessageSquare className="w-3 h-3 text-[#00aae5]" />
 *                           <span className="text-xs text-[#00aae5]">Comment Reply</span>
 *                         </div>
 *                         <p className="text-sm text-[#2b2b2b]">{activity.reply_text}</p>
 *                       </div>
 *                     )}
 *                     {activity.message_text && activity.message_text.trim() != '' && (
 *                       <div className="border border-purple-200 rounded-lg p-3">
 *                         <div className="flex items-center gap-2 mb-1">
 *                           <Send className="w-3 h-3 text-[#2b2b2b]" />
 *                           <span className="text-xs text-[#2b2b2b]">DM Sent</span>
 *                         </div>
 *                         <p className="text-sm text-[#2b2b2b]">{activity.message_text}</p>
 *                       </div>
 *                     )}
 *                   </div>
 *                   <div className="flex items-center gap-4 text-xs text-gray-500">
 *                     <span className="flex items-center gap-1">
 *                       <Calendar className="w-3 h-3" />
 *                       {formatTimeAgo(activity.timestamp)}
 *                     </span>
 *                     <Button
 *                       variant="link"
 *                       size="sm"
 *                       className="h-auto p-0 text-xs text-[#2b2b2b]"
 *                       onClick={() => window.open(activity.permalink, '_blank')}
 *                     >
 *                       <ExternalLink className="w-3 h-3 mr-1" />
 *                       View post
 *                     </Button>
 *                   </div>
 *                 </div>
 *               </div>
 *               );
 *             })
 *           )}
 *           {hasMore && isLoading && activities.length > 0 && (
 *             [...Array(3)].map((_, i) => <ActivitySkeleton key={`more-${i}`} />)
 *           )}
 *           <>
 *             {hasMore && (
 *               <div
 *                 ref={loadMoreRef}
 *                 className="flex justify-center py-4 text-sm text-gray-400"
 *               >
 *                 {isLoading ? "Loading more activities..." : "Scroll to load more"}
 *               </div>
 *             )}
 *           </>
 *         </div>
 *       </CardContent>
 *     </Card>
 *   );
 * }
 * ========================================================================== */

const mapStateToProps = (state: any) => {
  return {
    UserReducer: state.UserReducer.UserData,
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    loading: (data: any) => dispatch(Loading(data)),
    updateUser: (data: any) => dispatch(UserLogin(data)),
  };
};

const connectToRedux = connect(
  mapStateToProps,
  mapDispatchToProps
)(ActivityLog);

export { connectToRedux as ActivityLog };
